module.exports = __webpack_public_path__ + "img/rwgj-nav.7783070.svg";